import React from 'react'
import { Contacts } from '../components/index'

const ContactsPage = () => {
    return (
        <div className="App">
            <Contacts />
        </div>
    )
}

export default ContactsPage